export default {
  path: '/f/:slug',
  name: 'orderFormPublic',
  meta: { title: '订购表单', public: true },
  component: () => import('@/views/orderForm/public/FillPage'),
}
